import type { LucideIcon } from "lucide-react";
import type { ReactNode } from "react";

import { cn } from "@/lib/utils";

type PageEyebrowVariant = "brand" | "emerald" | "blue" | "neutral";

const VARIANT_CLASSES: Record<PageEyebrowVariant, string> = {
  brand:
    "border-brand-accent/20 bg-brand-accent/5 text-brand-accent dark:border-brand-primary/30 dark:bg-brand-primary/10 dark:text-brand-primary",
  emerald: "border-success/30 bg-success-muted text-success-foreground",
  blue: "border-info/30 bg-info-muted text-info-foreground",
  neutral: "border-border/60 bg-surface text-muted-foreground",
};

interface PageEyebrowProps {
  children: ReactNode;
  className?: string;
  icon?: LucideIcon;
  variant?: PageEyebrowVariant;
}

export function PageEyebrow({
  children,
  className,
  icon: Icon,
  variant = "brand",
}: PageEyebrowProps) {
  return (
    <div
      className={cn(
        "inline-flex items-center gap-2 rounded-full border px-4 py-1.5 text-sm",
        VARIANT_CLASSES[variant],
        className,
      )}
    >
      {Icon ? <Icon className="size-4 shrink-0" /> : null}
      <span className="font-medium">{children}</span>
    </div>
  );
}